<template lang="pug">
transition(
  v-on:enter="enter"
  v-on:leave="leave"
  )
  .qr-page
    svg.bg(ref="bg" viewBox="0 0 100 100" fill="transparent" @click="svgclick")
      clipPath(id="bg-clip")
        circle(
          cx="50" cy="50" :r="p"
        )
      g
        rect(x="0" y="0" width="100" height="100" fill="#3A54A2" clip-path="url(#bg-clip)")
      image(id="qrcode" xlink:href="~assets/ui/qroffical.jpg" x="40" y="40" width="20" height="20" clip-path="url(#bg-clip)")
      g(clip-path="url(#bg-clip)" id="close")
        path(d="M51.7365 74.1299C51.0527 74.6773 50.1843 74.8615 49.3265 74.6625C48.4638 74.4162 47.6765 72.9682 47.6926 72.1546C47.6819 70.1019 50.1215 69.3753 51.5629 70.4699C52.8876 71.3855 53.1087 73.0823 51.7365 74.1299Z" fill="white")
        path(d="M50.9353 71.3262C50.632 71.6379 50.3196 71.9422 50.0164 72.2539C49.9888 72.2762 49.9888 72.3059 50.0164 72.3355C50.3196 72.6473 50.632 72.9515 50.9353 73.2633C50.9904 73.3226 51.0915 73.241 51.0364 73.1816C50.8801 73.0258 50.7331 72.8699 50.5769 72.7215C50.5126 72.6547 50.4391 72.5879 50.3748 72.5137C50.3288 72.4691 50.1267 72.2465 50.1267 72.291C50.1267 72.3355 50.3288 72.1129 50.3748 72.0684C50.4391 72.0016 50.5126 71.9348 50.5769 71.8605C50.7331 71.7047 50.8801 71.5488 51.0364 71.4004C51.0823 71.3484 50.9904 71.2668 50.9353 71.3262Z" fill="#3A54A2")
        path(d="M49.0975 71.4004C49.2537 71.5563 49.4007 71.7121 49.5569 71.8605C49.6213 71.9273 49.6948 71.9941 49.7591 72.0684C49.805 72.1129 50.0072 72.3355 50.0072 72.291C50.0072 72.2465 49.805 72.4691 49.7591 72.5137C49.6948 72.5805 49.6213 72.6473 49.5569 72.7215C49.4007 72.8773 49.2537 73.0332 49.0975 73.1816C49.0424 73.2336 49.1434 73.3152 49.1986 73.2633C49.5018 72.9516 49.8142 72.6473 50.1175 72.3355C50.145 72.3133 50.145 72.2836 50.1175 72.2539C49.805 71.9422 49.5018 71.6305 49.1894 71.3262C49.1343 71.2668 49.0424 71.3484 49.0975 71.4004Z" fill="#3A54A2")

//.bg(ref="bg")
      .card
        .qr-code
        .copy
      .button-close(@click="closeQRPage")
        icon-close

</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2, Circ} from 'gsap'
import IconClose from 'src/components/vca/widgets/IconClose'
//import Component from '@/components/Component'

export default {
  name: "QRPage",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    IconClose
  },
  data() {
    return {
      progress: 0
    }
  },
  computed:{
    p(){
      return this.progress*28
    }
  },
  methods: {
    ...mapMutations('app', ['closeQRPage']),
    init() {},
    animateIn(cb) {

      let tl = new TimelineMax({ onComplete: cb})
      this.tl = tl
      let sw = window.innerWidth
      let sh = window.innerHeight
      let R = Math.sqrt(Math.pow(sw, 2)+ Math.pow(sh, 2))
      let xoff = (R - sw)/2
      let yoff = (R - sh)/2

      tl.add('start')
        .set(
          this.$refs.bg,
          {
            width: R,
            height: R,
            x: -xoff,
            y: -yoff,
          }
        )
        .to(
          this,
          1,
          {
            progress: 1,
            ease: Sine.easeIn
          },
          `start+=0.5`
        )

    },

    enter(el, done){
      this.animateIn(done)
    },
    leave(el, done){
      //this.animateOut(done)
      done()
    },
    svgclick(e){
      console.log(e)
      if (e.target.parentElement.id === 'close'){
        let tl = new TimelineMax({ onComplete: () => {
          this.closeQRPage()
          } })
        this.tl = tl

        tl.add('start')
          .to(
            this,
            1,
            {
              progress: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      }

    }
  },
  mounted() {
    this.init()
    //this.animate()
    //this.animateIn()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass">
  @import "src/styles/common.sass"
  .qr-page
    +full()
    line-height: 0
    pointer-events: all
    //background-color: red
    .bg
      //width: 100%
      //height: 100%
      position: absolute
      top: 0
      left: 0
      transform-origin: center
      //background: $cl-blue
      border-radius: 50%
      display: flex
      justify-content: center
      align-items: center
      overflow: hidden
      .card
        pointer-events: all
        width: 2.5rem
        height: 2.5rem
        //background: white
        border-radius: 1rem
        position: relative
      .button-close
        pointer-events: all
        width: 0.4rem
        height: 0.4rem
        background: #e15125
        .icon-close
          //svg
            stroke: $cl-blue !important






</style>